import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ButtonTooltip, ComponentDataTable, DefaultModal, Icon, SimpleCenteredModal } from '../../components';
import columns from './column';
import { debounceIndexShiftsRequest, exportShiftRequest } from '../../requests/shifts';
import { sendAlert } from '../../actions/utils';
import { downloadFile } from '../../services/utils';
import ShiftInfo from '../Profile/Shift/ShiftInfo';

const ShiftInfoDataTable = ({ moreData }) => {
  const [onRequest, setOnRequest] = useState(true);
  const [shifts, setShifts] = useState([]);
  const [amount, setAmount] = useState(0);
  const [modalAction, setModalAction] = useState(() => null);
  const [modalTitle, setModalTitle] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [simpleModalShow, setSimpleModalShow] = useState(false);
  const [simpleModalTitle, setSimpleModalTitle] = useState('');
  const [simpleModalBody, setSimpleModalBody] = useState('');
  const dispatch = useDispatch();

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setShifts(data);
    setAmount(metadata.amount);
    setOnRequest(false);
  };

  const handleRequest = params => {
    const modifiedParams = {
      ...params,
      active: true
    };

    const request = async () => {
      setOnRequest(true);
      debounceIndexShiftsRequest({ dispatch, params: modifiedParams, successCallback: handleSuccessIndex });
    };
    request();
  };

  const handleFailureRequest = error => {
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const massiveExportShift = () => {
    setModalShow(true);
    exportShiftRequest({
      dispatch,
      params: { active: true },
      successCallback: response => {
        setModalShow(false);
        downloadFile(response);
        setOnRequest(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleMassAction = action => {
    switch (action) {
      case 'export':
        setModalTitle('Exportar Turnos');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas exportar los turnos?');
        setModalAction(() => massiveExportShift);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const handleSimpleModalClose = () => {
    setSimpleModalShow(false);
  };

  const handleShowInfo = item => {
    setSimpleModalTitle('');
    setSimpleModalBody(<ShiftInfo customId={item.id} customTitle="Información del Turno" />);
    setSimpleModalShow(true);
  };

  return (
    <div className="data-table-yellow">
      <ComponentDataTable
        onRequest={onRequest}
        columns={columns(handleShowInfo)}
        data={shifts}
        totalRows={amount}
        moreData={moreData}
        resourceRequest={handleRequest}
        withMassActions
        massActions={
          <>
            <ButtonTooltip
              variant="circle-primary"
              className="mr-2 btn-circle mb-3"
              text="Exportar"
              onClick={() => handleMassAction('export')}
            >
              <Icon icon="download-2" />
            </ButtonTooltip>
          </>
        }
      />
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={() => setModalShow(false)}
        handleConfirm={() => modalAction()}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        disabled={onRequest}
      />

      <SimpleCenteredModal
        title={simpleModalTitle}
        body={simpleModalBody}
        size="xl"
        show={simpleModalShow}
        onHide={handleSimpleModalClose}
      />
    </div>
  );
};

export default ShiftInfoDataTable;
